<ng-template #template>
  <ng-container *ngIf="notifier.isDisplayed">
    <div [class]="notifier.css" [style]="{ visibility: notifier.active ? 'visible' : 'hidden' }" role="alert" aria-live="polite">
      <span>{{notifier.message}}</span>
      <sv-action-bar [model]="notifier.actionBar"></sv-action-bar> 
    </div>
  </ng-container>
</ng-template>